import SInputComponent from './sInput'
import sInputShowComponent from './sInputShow.vue'
import sInputsContrast from './sContrast.vue'

const SInput = {
  install:function(Vue){
    Vue.component('SInput',SInputComponent);
    Vue.component('sContrast',sInputsContrast);
    Vue.component('sInputShow',sInputShowComponent)
  }
};

export default SInput



// WEBPACK FOOTER //
// ./src/components/s-input/index.js